// # 캔버스는 처음 열 때 받는다
//
// `CanvasSync` 는 Yjs(와 lib0)를 끌고 온다 — 첫 청크의 3할이다. 캔버스는 첫 화면에 없으므로
// 판을 처음 열 때 따로 받는다(허들의 `livekit-client` 와 같다). 그래서 `@maru/client` 배럴은
// 캔버스를 싣지 않고, 여기만 `@maru/client/canvas` 를 동적으로 부른다.
//
// 받는 동안 온 부름은 받은 뒤 **온 순서대로** 넘긴다(약속 하나에 줄 세운다). 받기 전에 닫으면
// 받자마자 닫는다(닫기도 같은 줄에 선다) — 닫힌 판이 소켓을 계속 엿들으면 안 된다.

import type { CanvasConfig, CanvasView } from '@maru/client/canvas'
import type { CanvasHandle } from '@maru/ui'

const FAILED: CanvasView = {
  status: 'failed',
  title: '',
  by: null,
  text: '',
  saving: false,
  peers: [],
  // 실패 문장은 판(`CanvasBody`)이 화면 언어로 그린다. 여기에도 적으면 같은 말이 두 번 뜬다.
  error: null,
}

export function open_canvas(config: CanvasConfig): CanvasHandle {
  let closed = false
  const ready = import('@maru/client/canvas').then(
    ({ CanvasSync }) => new CanvasSync(config),
    (e: unknown) => {
      if (!closed) config.listen(FAILED)
      throw e
    },
  )
  // 받기에 실패하면 부름마다 같은 거절을 되풀이하지 않는다 — 화면에는 이미 알렸다.
  ready.catch(() => {})
  return {
    edit: (next) => {
      void ready.then(
        (s) => s.edit(next),
        () => {},
      )
    },
    here: (at, end) => {
      void ready.then(
        (s) => s.here(at, end ?? at),
        () => {},
      )
    },
    create: async (title) => (await ready).create(title),
    retitle: async (title) => (await ready).retitle(title),
    remove: async () => (await ready).remove(),
    close: () => {
      if (closed) return
      closed = true
      void ready.then(
        (s) => s.close(),
        () => {},
      )
    },
  }
}
